import { deepClone } from './deepClone';

type LogTarget = 'tracking' | 'typo3';
type LogData = any;

function log(target: LogTarget, severity: 'info' | 'warn' | 'error' | 'debug', data: LogData[]) {
    if (process.env.NODE_ENV === 'production') {
        return;
    }

    if (localStorage.getItem('log.all') !== '1' && localStorage.getItem(`log.${target}`) !== '1') {
        return;
    }

    let normalizedData: LogData[];

    if (target === 'tracking') {
        // This is needed because Matomo directly transforms the tracking data and therefore different values are displayed in the console
        normalizedData = deepClone(data);
    } else {
        normalizedData = data;
    }

    console[severity](`[${target}]`, ...normalizedData);
}

export const logger = {
    info: (target: LogTarget, ...data: LogData[]) => log(target, 'info', data),
    warn: (target: LogTarget, ...data: LogData[]) => log(target, 'warn', data),
    error: (target: LogTarget, ...data: LogData[]) => log(target, 'error', data),
    debug: (target: LogTarget, ...data: LogData[]) => log(target, 'debug', data),
};
